
<mat-card
    class="trinta-card basic-form mb-25 bg-white border-none d-block"
>
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                Add new user
            </h5>
            <p>The added user will receive an email with further instructions.</p>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div *ngIf="successMessage" class="alert alert-success">
            {{ successMessage }}
        </div>
        <div *ngIf="contentLoading" style="margin-top: 50px;">
          <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">
            <mat-progress-bar mode="indeterminate" style="width: 50%;"></mat-progress-bar>
          </div>
        </div>

        <!-- Error message -->
        <div *ngIf="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
        </div>
        <form [formGroup]="profileForm" (submit)="onSubmit()">
            <label for="username" class="label d-block fw-medium mb-10" style="font-size: 16px;">
                Username
            </label>
            <mat-form-field>
                <i-feather name="user"></i-feather>
                <mat-label style="font-size: 16px;">Enter username</mat-label>
                <input style="font-size: 16px;" matInput formControlName="username">
            </mat-form-field>
            <label for="email" class="label d-block fw-medium mb-10" style="font-size: 16px;">
                Email Address
            </label>
            <mat-form-field>
                <i-feather name="mail"></i-feather>
                <mat-label style="font-size: 16px;">Enter email address</mat-label>
                <input style="font-size: 16px;" matInput formControlName="email">
            </mat-form-field>
            <label for="repeatEmail" class="label d-block fw-medium mb-10" style="font-size: 16px;">
                Repeat Email Address
            </label>
            <mat-form-field>
                <i-feather name="mail"></i-feather>
                <mat-label style="font-size: 16px;">Repeat email address</mat-label>
                <input style="font-size: 16px;" matInput formControlName="repeatEmail">
            </mat-form-field>

            <button [disabled]="profileForm.invalid || contentLoading" mat-button type="submit" style="max-width: 200px;">
                Add user
            </button>
        </form>
    </mat-card-content>
</mat-card>
